import styles from './CheckAnimation.module.css';

export const CheckAnimation = () => (
  <div
    className={styles.checkAnimation}
    data-testid="check-animation"
    role="img"
    aria-label="Success checkmark icon"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="361"
      height="362"
      viewBox="0 0 361 362"
      fill="none"
    >
      <ellipse opacity="0.8" cx="180.5" cy="181" rx="180.5" ry="181" fill="#668CFC" />
      <ellipse opacity="0.24" cx="180.5" cy="181.5" rx="118.457" ry="119.5" fill="#99B3FD" />
      <g filter="url(#filter0_d_30239_296166)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M179.999 235.124C210.444 235.124 235.124 210.444 235.124 179.999C235.124 149.554 210.444 124.874 179.999 124.874C149.554 124.874 124.874 149.554 124.874 179.999C124.874 210.444 149.554 235.124 179.999 235.124ZM202.369 161.827L202.39 161.806H202.347L202.369 161.827ZM202.369 161.827L172.58 191.912L166.601 185.933L157.611 176.901L151.59 182.88L168.509 199.884L168.891 200.266C171.096 202.089 174.403 202.047 176.523 199.927L183.944 192.506L208.369 167.785L202.369 161.827Z"
          fill="#F3F5FF"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_30239_296166"
          x="105"
          y="107"
          width="150"
          height="150"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0392157 0 0 0 0 0.0823529 0 0 0 0 0.207843 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_30239_296166"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_30239_296166"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  </div>
);
